import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Calendar
import calendar from "./calendar/reducer";

// Authentication
import forgetPassword from "./auth/forgetpwd/reducer";
import login from "./auth/login/reducer";
import profile from "./auth/profile/reducer";
import account from "./auth/register/reducer";
import mails_redux from "./email/reducer";
import Modal from "./modal/reducer";
import GeneralStateRedux from "./generalState/reducer";
import subscription from "./subscription/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  calendar,
  forgetPassword,
  login,
  profile,
  account,
  Modal,
  mails_redux,
  GeneralStateRedux,
  subscription,
});

export default rootReducer;
